export default {
  tabsLabel: {
    id: 'header_bo_tabs_label',
    defaultMessage: 'Links sales',
  },
  home: {
    id: 'header_bo_home',
    defaultMessage: 'Home',
  },
  onboardingHome: {
    id: 'header_bo_on_boarding_home',
    defaultMessage: 'Onboarding',
  },
  performances: {
    id: 'header_bo_performances',
    defaultMessage: 'Performances',
  },
  insights: {
    id: 'header_bo_insights',
    defaultMessage: 'Insights',
  },
  sav: {
    id: 'header_bo_sav',
    defaultMessage: 'Customer Service requests',
  },
  listings: {
    id: 'header_bo_products',
    defaultMessage: 'Offers',
  },
  orders: {
    id: 'header_bo_orders',
    defaultMessage: 'Orders',
  },
  customerCare: {
    id: 'header_bo_sav',
    defaultMessage: 'Customer Care',
  },
  opportunities: {
    id: 'header_bo_opportunities',
    defaultMessage: 'Opportunities',
  },
  invoices: {
    id: 'header_bo_invoices',
    defaultMessage: 'Invoices',
  },
  options: {
    id: 'header_bo_options',
    defaultMessage: 'Options',
  },
  support: {
    id: 'header_bo_support',
    defaultMessage: 'Support',
  },
}
